
const billTypes = [
    "VESSEL_SPARE_SALES",
    "PURIFIER_SPARE_SALES",
    "OFFICE_SPARE_SALES",
    "PRODUCT_SALES",
    "OUTSIDE_SALES"
]

const billStatuses = [
    'DRAFT',
    "ISSUED",
    'VOIDED'
]

const billSources = ['OFFICE', 'FIELD', 'ONLINE', 'SYSTEM']

const billParties = [
    "CUSTOMER",
    "ASSOCIATE",
    "EMPLOYEE",
    "INTERNAL"  // if not party
]

const billReferences = [
    "SALES",
    "PURIFIER_SERVICE",
    "VESSEL_SERVICE"
]


const receiptTypes = [
    "PAYMENT",
    "ADVANCE",
    "SETTLEMENT",
    "ADJUSTMENT",
    "REFUND"
]

const receiptStatuses = [
    "PENDING",
    "PARTIALLY_VERIFIED",
    "VERIFIED",
    "FAILED",
    "CANCELLED"
]

const receiptDirections = ['INFLOW', 'OUTFLOW']

const receiptPaymentModes = [
    'CASH',
    'BANK',
    'WALLET',
    'CHEQUE',
    'UPI',
    'QR',
    'CARD',
    'EMI'
]

const transactionStatus = ['INITIATED', "PENDING_CLEARANCE", 'SUCCESS', 'REJECTED', 'BOUNCED']


module.exports = {
    billTypes,
    billStatuses,
    billSources,
    billParties,
    billReferences,
    receiptTypes,
    receiptStatuses,
    receiptDirections,
    receiptPaymentModes,
    transactionStatus
}